module.exports = __webpack_public_path__ + "img/Poverty.b0a02037.png";